export default "__VITE_ASSET__BHfWJLzE__"